"use strict";

var _classCallCheck = require("/home/rodrigo/repo/clinica-oral-prime-gatsby-landing/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Range = void 0;

var Range = function Range(x, y) {
  _classCallCheck(this, Range);

  this.position = {
    x: x,
    y: y
  };
};

exports.Range = Range;